!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.SimpleMaskMoney = t();
}(this, function () {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      e = function () {
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var i = t[r];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    return function (e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    };
  }();

  var i = function () {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.allowNegative = !1, this.negativeSignAfter = !1, this.decimalSeparator = ",", this.fixed = !0, this.fractionDigits = 2, this.prefix = "", this.suffix = "", this.thousandsSeparator = ".", this.cursor = "move", this.merge(e);
    }

    return e(t, [{
      key: "merge",
      value: function value(e) {
        e && "object" === (void 0 === e ? "undefined" : r(e)) && (this.fixed = "boolean" == typeof e.fixed ? e.fixed : this.fixed, this.allowNegative = "boolean" == typeof e.allowNegative ? e.allowNegative : this.allowNegative, this.negativeSignAfter = "boolean" == typeof e.negativeSignAfter ? e.negativeSignAfter : this.negativeSignAfter, this.decimalSeparator = void 0 === e.decimalSeparator ? this.decimalSeparator : e.decimalSeparator, this.fractionDigits = void 0 === e.fractionDigits ? this.fractionDigits : e.fractionDigits, this.prefix = void 0 === e.prefix ? this.prefix : e.prefix, this.suffix = void 0 === e.suffix ? this.suffix : e.suffix, this.thousandsSeparator = void 0 === e.thousandsSeparator ? this.thousandsSeparator : e.thousandsSeparator, this.cursor = void 0 === e.cursor ? this.cursor : e.cursor);
      }
    }]), t;
  }(),
      n = function () {
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var i = t[r];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    return function (e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    };
  }();

  var t = function () {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.args = new i(e);
    }

    return n(t, [{
      key: "completer",
      value: function value() {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1;
        return this.args.fixed ? "".padEnd(e, "0") : "".padEnd(e, "_");
      }
    }, {
      key: "emptyOrInvalid",
      value: function value() {
        return "" + this.completer() + this.args.decimalSeparator + this.completer(this.args.fractionDigits);
      }
    }, {
      key: "onlyNumber",
      value: function value(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          isFinite(e[r]) && (t += e[r]);
        }

        return t;
      }
    }, {
      key: "addingPrefix",
      value: function value(e) {
        return "" + this.args.prefix + e;
      }
    }, {
      key: "removingPrefix",
      value: function value(e) {
        return e.replace(this.args.prefix, "");
      }
    }, {
      key: "addingSuffix",
      value: function value(e) {
        return "" + e + this.args.suffix;
      }
    }, {
      key: "removingSuffix",
      value: function value(e) {
        return e = e.includes(this.args.suffix, e.length - this.args.fractionDigits) ? e.replace(this.args.suffix, "") : e.substring(0, e.length - 1);
      }
    }, {
      key: "addingCompleterFromStart",
      value: function value(e, t) {
        for (; e.length < this.args.fractionDigits;) {
          e = "" + t + e;
        }

        return e;
      }
    }, {
      key: "addingCompleterFromEnd",
      value: function value(e, t) {
        for (; e.length < this.args.fractionDigits;) {
          e = "" + e + t;
        }

        return e;
      }
    }, {
      key: "removingCompleterFromStart",
      value: function value(e, t) {
        for (; e[0] === t;) {
          e = e.replace(t, "");
        }

        return e;
      }
    }, {
      key: "removingCompleterFromEnd",
      value: function value(e, t) {
        for (; e[e.length - 1] === t;) {
          e = e.substring(0, e.length - 1);
        }

        return e;
      }
    }, {
      key: "addingAutoComplete",
      value: function value(e) {
        return "" + e + this.addingCompleterFromEnd("", "0");
      }
    }, {
      key: "autoComplete",
      value: function value(e) {
        var t = new RegExp("\\" + this.args.decimalSeparator, "g");
        return 1 < (e.match(t) || []).length && (e = this.addingAutoComplete(e)), e;
      }
    }, {
      key: "addingDecimalSeparator",
      value: function value(e, t, r) {
        var i = e.length - this.args.fractionDigits,
            n = void 0,
            a = "$1",
            o = t,
            s = isFinite(t) ? "d" : "w";
        return n = "(\\" + s + "{" + this.args.fractionDigits + "})", 0 < i && (n = "(\\" + s + "{" + i + "})" + n, o = a, a = "$2"), e.replace(new RegExp(n), "" + o + r + a);
      }
    }, {
      key: "addingHundredsSeparator",
      value: function value(e) {
        for (var t = e.length - this.args.fractionDigits, r = Math.ceil(t / 3), i = "(\\d)", n = this.args.decimalSeparator + "$" + (r + 1), a = r; 0 !== a; a--) {
          3 <= t ? (i = "(\\d{3})" + i, t -= 3) : i = "(\\d{" + t + "})" + i, n = 1 < a ? this.args.thousandsSeparator + "$" + a + n : "$" + a + n;
        }

        return e.replace(new RegExp(i), n);
      }
    }, {
      key: "removeSeparator",
      value: function value(e, t) {
        return e.replace(new RegExp("\\" + t, "g"), "");
      }
    }, {
      key: "formatDecimal",
      value: function value(e, t, r) {
        return e = this.addingCompleterFromStart(e, t), e = this.addingDecimalSeparator(e, t, r);
      }
    }, {
      key: "textToNumber",
      value: function value(e) {
        var t = e.toString(),
            r = this.completer();
        return this.args.prefix && (t = this.removingPrefix(t)), this.args.suffix && (t = this.removingSuffix(t)), t = this.removeSeparator(t, this.args.thousandsSeparator), t = this.removeSeparator(t, this.args.decimalSeparator), t = this.onlyNumber(t), (t = this.removingCompleterFromStart(t, r)) || (this.args.fixed ? "0" : "");
      }
    }, {
      key: "numberToText",
      value: function value(e) {
        var t = this.emptyOrInvalid();
        return isNaN(parseFloat(e)) || (t = e.length <= this.args.fractionDigits ? this.formatDecimal(e, this.completer(), this.args.decimalSeparator) : this.addingHundredsSeparator(e)), this.args.prefix && (t = this.addingPrefix(t)), this.args.suffix && (t = this.addingSuffix(t)), t;
      }
    }]), t;
  }(),
      s = function s(e) {
    var t = -1;
    if ("selectionStart" in e) t = e.selectionStart;else if (document.selection) {
      e.focus();
      var r = document.selection.createRange(),
          i = document.selection.createRange().text.length;
      r.moveStart("character", -e.value.length), t = r.text.length - i;
    }
    return t;
  },
      u = function u(e, t) {
    if (e.setSelectionRange) e.focus(), e.setSelectionRange(t, t);else if (e.createTextRange) {
      var r = e.createTextRange();
      r.collapse(!0), r.moveEnd("character", t), r.moveStart("character", t), r.select();
    }
  },
      f = function f(e, t) {
    var r = void 0;

    switch (!0) {
      case t.length < e.length:
        r = -1;
        break;

      case t.length > e.length:
        r = 1;
        break;

      default:
        r = 0;
    }

    return r;
  },
      a = function () {
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var i = t[r];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
      }
    }

    return function (e, t, r) {
      return t && i(e.prototype, t), r && i(e, r), e;
    };
  }();

  var l = new i(),
      c = new t(l);
  return function () {
    function o() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, o), l = new i(), c = new t(l), Object.defineProperty(this, "args", {
        get: function get() {
          return l;
        },
        set: function set(e) {
          l = new i(e), c = new t(l);
        }
      }), this.formatToNumber = o.formatToNumber, this.format = o.format, this.setMask = o.setMask;
    }

    return a(o, null, [{
      key: "format",
      value: function value(e) {
        var t = l.allowNegative && -1 !== e.indexOf("-"),
            r = c.numberToText(c.textToNumber(e));
        return (!l.negativeSignAfter && t ? "-" : "") + r + (l.negativeSignAfter && t ? "-" : "");
      }
    }, {
      key: "formatToNumber",
      value: function value(e) {
        var t = "0",
            r = c.textToNumber(e),
            i = l.allowNegative && -1 !== e.indexOf("-");

        if (i && r.replace("-", ""), !isNaN(parseFloat(r))) {
          if (r.length <= l.fractionDigits) r = c.formatDecimal(r, "0", ".");else {
            var n = r.length - l.fractionDigits;
            r = r.replace(new RegExp("(\\d{" + n + "})(\\d{" + l.fractionDigits + "})"), "$1.$2");
          }
          t = r;
        }

        return parseFloat(i ? -1 * t : t);
      }
    }, {
      key: "setMask",
      value: function value(e, t) {
        if ("undefined" == typeof document) throw "This function only works on client side";
        var a = "string" == typeof e ? document.querySelector(e) : e;
        return t && (o.args = t), a.addEventListener("input", function (e) {
          var t = a.value,
              r = o.format(t),
              i = s(a) - f(r, t),
              n = o.args.cursor;
          "start" === n ? i = 0 : "end" === n && (i = r.length), a.value = r, a._value = r, u(a, i), !(e instanceof Event) && a.dispatchEvent(new Event("input"));
        }), a.formatToNumber = function () {
          return o.formatToNumber(a.value);
        }, a;
      }
    }, {
      key: "args",
      get: function get() {
        return l;
      },
      set: function set(e) {
        l = new i(e), c = new t(l);
      }
    }]), o;
  }();
});